/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { AbsenceDetailComponent } from './absence-detail/absence-detail.component';
import { AbsencesComponent } from './absences/absences.component';

@NgModule({
    declarations: [
        AbsencesComponent,
        AbsenceDetailComponent
    ],
    imports: [
        SharedModule
    ],
    exports: [AbsencesComponent]
})
export class AbsencesModule { }
